export class CellphoneAlreadyRegisteredError extends Error {
  constructor() {
    super("The provided cellphone is already registered.");
    this.name = "CellphoneAlreadyRegisteredError";
  }
}
